const state = {
  activeCompanyId: '',
  activeHotelId: '',
  activeAgentId: '',
  hotelList: [],
  agentList: []
}

const getters = {
  getActiveHotelId: () => state.activeHotelId
}

const actions = {
  setActiveCompanyId (context, payLoad) {
    context.commit('setActiveCompanyId', payLoad)
  },
  setActiveHotelId (context, payLoad) {
    context.commit('setActiveHotelId', payLoad)
  },
  setActiveAgentId (context, payLoad) {
    context.commit('setActiveAgentId', payLoad)
  },
  setHotelList (context, payLoad) {
    context.commit('setHotelList', payLoad)
  },
  restoreState (context, payLoad) {
    context.commit('setActiveCompanyId', payLoad.companyId)
    context.commit('setActiveHotelId', payLoad.hotelId)
    context.commit('setHotelList', payLoad.hotelList)
  }
}

const mutations = {
  setActiveCompanyId (state, payLoad) {
    state.activeCompanyId = payLoad
  },
  setActiveHotelId (state, payLoad) {
    state.activeHotelId = payLoad
  },
  setActiveAgentId (state, payLoad) {
    state.activeAgentId = payLoad
  },
  setHotelList (state, payLoad) {
    state.hotelList = payLoad.sort((a, b) => {
      return (a.name > b.name) ? 1 : -1
    })
  }

}

export default {
  name: 'general',
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
